<template>
  <b-card
    no-body
    :header="$t('Estados por sitios')"
    border-variant="primary"
    header-bg-variant="primary"
    header-text-variant="white"
    my="0"
    class="w-100"
  >
    <b-modal ref="confirmationModal" title="Cambio de estado">
      <moon-loader class="mb-2" :loading="loading" color="#000" size="30px"></moon-loader>
      <span v-show="!loading" class="my-4">{{ confirmationModal.message }}</span>
      <template #modal-footer>
        <div class="w-100">
          <b-button
            variant="primary"
            class="float-right"
            @click="changeStatus"
            :disabled="loading"
          >
            {{ confirmationModal.okLabel }}
          </b-button>
        </div>
        <b-button
          variant="secondary"
          class="float-right mr-2"
          @click="$refs.confirmationModal.hide()"
          :disabled="loading"
        >
          {{ $t('Cancelar') }}
        </b-button>
      </template>
    </b-modal>
    <b-table
      responsive=true
      show-empty
      :items="sku.marketplaces"
      :fields="tableFields"
      :empty-text="$t('No hay variantes para mostrar')"
      class="mb-0"
    >
      <template slot="status" slot-scope="item">
        <b v-if="item.value === 'APPROVED'" class="text-success">
          {{$t(productStates.find(p => p.value === item.value).text)}}
        </b>
        <b v-if="item.value === 'REJECTED'" class="text-danger">
          {{$t(productStates.find(p => p.value === item.value).text)}}
        </b>
        <b v-if="item.value === 'PENDING_APPROVAL'" class="text-warning">
          {{$t(productStates.find(p => p.value === item.value).text)}}
        </b>
      </template>
      <template slot="action" slot-scope="item">
        <b-button
          type="button"
          size="sm"
          v-show="isAdmin && canWrite"
          :disabled="actionDisabled(item.item)"
          :variant="getVariant(item.item)"
          class="btn float-right"
          @click="confirmChangeStatus(item.item, 'REJECTED')"
        >
          {{$t('Rechazar')}}
        </b-button>
        <b-button
          type="button"
          size="sm"
          v-show="isAdmin && canWrite"
          :disabled="actionDisabled(item.item)"
          :variant="getVariant(item.item)"
          class="btn float-right mr-2"
          @click="confirmChangeStatus(item.item, 'APPROVED')"
        >
          {{$t('Activar')}}
        </b-button>
      </template>
    </b-table>
  </b-card>
</template>

<script>

import { ProductServiceMixim, PRODUCT_STATES } from '@/mixims/ProductServiceMixim.js'
import MoonLoader from 'vue-spinner/src/MoonLoader.vue'

export default {
  name: 'marketplace-statuses',
  components: { MoonLoader },
  mixins: [ProductServiceMixim],
  props: ['sku'],
  data() {
    return {
      selected: null,
      loading: false,
      actionHandler: () => {},
      action: null,
      isAdmin: this.$store.getters.isAdmin,
      canWrite: this.$store.getters.signedRoles.includes('PRODUCT_WRITE'),
      productStates: PRODUCT_STATES,
      tableFields: [
        { key: 'name', label: this.$t('Sitio'), tdClass: 'align-middle', 'class': 'text-left' },
        { key: 'status', label: this.$t('Estado'), tdClass: 'align-middle', 'class': 'text-left' },
        { key: 'action', label: ' ', 'class': 'text-right', sortable: false }
      ],
      confirmationModal: {
        message: '',
        okLabel: '',
      },
    }
  },
  methods: {
    actionDisabled(item) {
      return item.status === 'APPROVED' || item.status === 'REJECTED'
    },
    getVariant(item) {
      return this.actionDisabled(item) ? 'secondary' : 'primary'
    },
    confirmChangeStatus(item, newStatus) {
      this.selected = item
      this.action = newStatus
      this.actionHandler = newStatus === 'APPROVED' ? this.activateSku : this.rejectSku
      this.confirmationModal = {
        message: `¿Está seguro de que desea cambiar el estado a ${newStatus === 'APPROVED' ? 'Activo' : 'Rechazado'}?`,
        okLabel: newStatus === 'APPROVED' ? this.$t('Activar') : this.$t('Rechazar'),
      }
      this.$refs.confirmationModal.show()
    },
    changeStatus() {
      console.log(this.action, this.sku, this.selected)
      this.loading = true
      this.actionHandler(this.sku.id, this.selected)
        .then(
          (response) => {
            let res = response.body
            if (res.status?.code) {
              if (res.status.code !== '200') {
                const message = res.errors[0].description
                this.$emit('onChangeError', {
                  message: message || `Error ${this.action === 'APPROVED' ? 'activando' : 'rechazando'} el producto`,
                })
              } else {
                this.$emit('onChangeSuccess')
              }
            }
            this.loading = false
            this.$refs.confirmationModal.hide()
          },
          (error) => {
            this.$emit('onChangeError', { message: String(error) })
            this.loading = false
            this.$refs.confirmationModal.hide()
          }
        )
    }
  },
}
</script>